import { render, staticRenderFns } from "./RefList.vue?vue&type=template&id=6dedb75e&"
import script from "./RefList.vue?vue&type=script&lang=js&"
export * from "./RefList.vue?vue&type=script&lang=js&"
import style0 from "./RefList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RefList.vue"
export default component.exports